import React from 'react';
import fetchComponentData from '../server/fetchComponentData';
import { normalizeQueryString } from 'lib/format';

class ComponentDataContainer extends React.Component {
    componentDidMount() {
        const { routerProps } = this.props;
        this.onUpdate(routerProps);
    }

    componentDidUpdate(prevProps) {
        const { routerProps } = this.props;
        const prevRouterProps = prevProps.routerProps;
        this.onUpdate(routerProps, prevRouterProps);
    }

    onUpdate(routerProps, prevRouterProps = {}) {
        if (window.__INITIAL_STATE__ !== null) {
            window.__INITIAL_STATE__ = null;
            return;
        }

        // don't update if the route hasn't changed
        if (prevRouterProps.location && prevRouterProps.location.pathname === routerProps.location.pathname) {
            return;
        }

        // this `dispatch is passed from client.js
        const { dispatch, onLoadStart: onDefLoadStart, onComplete: onDefComplete } = this.props;
        const { components = [], params = {}, location: { query = {} } = {}, lang } = routerProps;
        // grab the ones that's defined in the deepest child
        const { onLoadStart, onComplete } = components.reduce((acc, current) => {
            if (current.onLoadStart) {
                acc.onLoadStart = current.onLoadStart;
            }
            if (current.onComplete) {
                acc.onComplete = current.onComplete;
            }
            return acc;
        }, { onLoadStart: onDefLoadStart, onComplete: onDefComplete });

        onLoadStart(dispatch);
        fetchComponentData(dispatch, components, params, normalizeQueryString(query), lang).then(() => onComplete(dispatch));
    }

    render() {
        return this.props.children;
    }
}

ComponentDataContainer.propTypes = {
    dispatch: React.PropTypes.func.isRequired,
    routerProps: React.PropTypes.object.isRequired,
    children: React.PropTypes.node.isRequired,
    onLoadStart: React.PropTypes.func,
    onComplete: React.PropTypes.func
};

ComponentDataContainer.defaultProps = {
    onLoadStart: () => {},
    onComplete: () => {}
};

export default ComponentDataContainer;



// WEBPACK FOOTER //
// ./app/ComponentDataContainer.js